module.exports = __webpack_public_path__ + "static/media/group.c496526f.svg";